import { createContext } from "react";
import { sourceInitialState } from "./sourceInitialState";


const SourceContext = createContext(sourceInitialState)

export default SourceContext